import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import bannerImage2 from "../../assets/images/bannerImage2.png";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "white",
  },
  paddingStyle: {
    padding: "0px 80px",
  },
  marginBottomStyle: {
    marginBottom: "5px",
  },
  marginBottomStyle2: {
    marginBottom: "25px",
  },
  fontStyle: {
    fontSize: "14px",
    marginBottom: 10,
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "4px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },

  divStyle: {
    width: "70%",
    margin: "auto",
    "& img": {
      maxWidth: "100%",
    },
  },
  fieldWrapper: {
    marginBottom: 10,
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 15,
    },
  },
  rightDiv: {
    minHeight: 300,
  },
  banner: {
    marginLeft: 90,
  },
  error: {
    marginBottom: 15,
  },
}));
const ForgotPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const { glob_pay_agent_auth } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response = await axios({
        url: `/api/v1/public/auth/forgot-password/send-otp?email=${email}`,
        method: "get",
      });
      history.push({ pathname: "/otp-send", state: { email: email } });
    } catch (error) {
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (glob_pay_agent_auth.access_token) {
      window.history.back();
    }
  }, []);

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.root}
      >
        <Grid>
          <Header />
        </Grid>
        <Grid>
          <Grid container alignItems="center" className={classes.paddingStyle}>
            <Grid item xs={6}>
              <div
                className={classes.divStyle}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img src={bannerImage2} alt="" className={classes.banner} />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={`${classes.divStyle} ${classes.rightDiv}`}>
                <Typography variant="h3" className={classes.marginBottomStyle}>
                  Forgot Password?
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.marginBottomStyle2}
                >
                  Enter your email address to reset your password.
                </Typography>

                <form onSubmit={handleSubmit}>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12}>
                      <Typography className={classes.fontStyle} gutterBottom>
                        Email
                      </Typography>
                      <TextField
                        id="email"
                        type="email"
                        required
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="contact@example.com"
                        className={classes.fieldWrapper}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      {loading ? <LinearProgress /> : null}
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        className={classes.buttonStyle}
                        disabled={loading}
                      >
                        Continue
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Footer />
        </Grid>
      </Grid>
    </div>
  );
};
export default ForgotPassword;
